export default __webpack_public_path__ + "static/media/mid.305965b0.svg";